import React from 'react';

import {
  BreadCrumb,
  CustomButton2,
  Pagination,
  ResponsiveView,
  TableHeader,
  TableLoading
} from '../../../../../../components';
import Components from './components';
import values from "../../../../../../values";
import Context from "../../../../../../context";
import WithdrawalComponent from "../../components";

type Props = {
  resultRequestWithdrawal: any;
}

const WithdrawalCompanyScreen: React.FC<Props> = (props: Props): React.ReactElement => {

  const { requestWithdrawal, setRequestWithdrawal, setShowModal } =
    React.useContext(Context.WithdrawalScreen);

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <section id="transactions-screen">
      <ResponsiveView.Row className="table-options-wrapper">
        <ResponsiveView.Column extraLarge={3} large={5} medium={5} className="bread-crumb-wrapper">
          <BreadCrumb/>
        </ResponsiveView.Column>
        <ResponsiveView.Column extraLarge={6} large={6} medium={7} className="search-and-filter-wrapper">
          {/*<Components.TimeFilter/>*/}
        </ResponsiveView.Column>
      </ResponsiveView.Row>
      <ResponsiveView.Container>
        <div className="table-content-wrapper">
          <table>
            <TableHeader headers={values.tableHeaders.WITHDRAWALS_COMPANY}/>
            {props.resultRequestWithdrawal?.status === "loading" ? (
              <TableLoading/>) : (<Components.Body data={props.resultRequestWithdrawal}/>
            )}
          </table>
        </div>
        <div style={{display: "flex", justifyContent: "center", marginTop: "2rem", gap: "1rem"}}>
          <div></div>
          <CustomButton2 title={'خروجی اکسل' } type='secondary' onClick={() => setShowModal('EXPORT_EXCEL' )}/>
          <CustomButton2 title={'تغییر وضعیت'} type='primary'   onClick={() => setShowModal('CHANGE_STATUS')}/>
        </div>
      </ResponsiveView.Container>
      {props.resultRequestWithdrawal?.status === "success" &&
        props.resultRequestWithdrawal?.data?.result?.totalDocs > 10 && (
          <div className="pagination">
            <Pagination
              page={requestWithdrawal?.page}
              totalPages={props.resultRequestWithdrawal?.data?.result?.totalPages}
              onPaginate={(page: number) => setRequestWithdrawal({...requestWithdrawal, page: page})}
            />
          </div>
        )}
      <WithdrawalComponent.ExportExcel  />
      <WithdrawalComponent.ChangeStatus />
    </section>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
}

export default WithdrawalCompanyScreen;
